import React, {useEffect} from "react";
import {connect} from "react-redux";
import {set} from "utils/organisation_store";

import CircularProgress from "@material-ui/core/CircularProgress";

import Permissioner from "utils/permissioner";
import {isInitialised} from "utils/uninitialised";
import setTitle from "utils/set_title";
import MatterListComponent from "../components/matter_list";
import {User} from "common/types/user";
import {Matter, MatterId} from "common/types/matter";
import fetchMattersAction from "modules/matters/actions/fetch";
import deleteMatterAction from "modules/matters/actions/delete";
import fetchProjectAction from "modules/projects/actions/project_fetch";
import {bindActionCreators} from "redux";
import requestor from "requestor";
import {Project, ProjectId} from "common/types/project";
import {OrganisationId} from "common/types/organisation";

interface MatterListContainerProps {
  matters: Matter[];
  user: User;
  project: Project;
  params: {
    organisationId: string;
    projectId: string;
  };
  deleteMatter: (
    organisationId: OrganisationId,
    projectId: ProjectId,
    matterId: MatterId,
  ) => Promise<void>;
}

function MatterListContainer(props: MatterListContainerProps) {
  const organisationId = parseInt(props.params.organisationId, 10);
  const projectId = parseInt(props.params.projectId, 10);

  useEffect(() => {
    set(props.params.organisationId, "projectId", props.params.projectId);
  }, [props.params.organisationId, props.params.projectId]);

  const shouldRenderContainer = isInitialised([
    props.user,
    props.matters,
    props.project,
  ]);

  if (!shouldRenderContainer || !props.user.permissions) {
    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  const permissioner = new Permissioner(props.user);
  if (
    !(permissioner.isAdmin() || permissioner.hasPermission("can-view-matters"))
  ) {
    return permissioner.getNoPermissionMessage();
  }
  const canUpdateProject = Boolean(
    permissioner.hasPermission("update-project"),
  );

  const deleteMatter = async (matterId: MatterId) => {
    return await props.deleteMatter(organisationId, projectId, matterId);
  };

  setTitle("Contractual Framework List");
  return (
    <MatterListComponent
      organisationId={organisationId}
      projectId={projectId}
      project={props.project}
      matters={props.matters}
      canUpdateProject={canUpdateProject}
      onDeleteMatter={deleteMatter}
      currentUserId={props.user.id}
    />
  );
}

function select(state) {
  return {
    user: state.user,
    matters: state.matters,
    project: state.project,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(
      {
        fetchMatters: fetchMattersAction(requestor),
        fetchProject: fetchProjectAction(requestor),
        deleteMatter: deleteMatterAction(requestor),
      },
      dispatch,
    ),
  };
}

export default connect(select, mapDispatchToProps)(MatterListContainer);
